export const defaultProps = {
    center: {
        lat: 29.28833971466329,
        lng: 47.97126041868609,
    },
    zoom: 10,
};
